export const reportShipmentsPerformanceTypes = {
  SET_SHIPMENTS_PERFORMANCE_FILTERS: 'SET_SHIPMENTS_PERFORMANCE_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL'
};
